// A device picked from an earlier enumeration can go stale — most commonly because
// enumerateDevices() only returns real camera IDs once video permission has actually
// been granted at least once, so a camera picked (or auto-picked) before that point
// carries a blank/placeholder ID that getUserMedia then can't resolve. Retry once,
// letting the browser pick any device of that kind, rather than surface a dead end.
export async function getUserMediaWithFallback(constraints) {
	try {
		return await navigator.mediaDevices.getUserMedia(constraints);
	} catch(e) {
		if(e.name !== 'NotFoundError' && e.name !== 'OverconstrainedError') throw e;
		const fallback = {};
		if(constraints.video) fallback.video = true;
		if(constraints.audio) fallback.audio = true;
		if(!fallback.video && !fallback.audio) throw e;
		console.error('getUserMedia failed for the selected device, retrying with any device', e);
		return await navigator.mediaDevices.getUserMedia(fallback);
	}
}

// Same call wrapped with a hard timeout, so a permission prompt the visitor never
// answers (or a stuck OS-level camera lock) fails loudly instead of hanging forever.
export function getUserMediaWithTimeout(constraints, timeoutMs = 25000) {
	return new Promise((resolve, reject) => {
		let done = false;
		const timer = setTimeout(() => {
			if(done) return;
			done = true;
			reject(new Error('Camera access timed out. Please allow camera/microphone in the browser permission bar, then reload.'));
		}, timeoutMs);
		getUserMediaWithFallback(constraints).then(
			s => { if(done) return s.getTracks().forEach(t => t.stop()); done = true; clearTimeout(timer); resolve(s); },
			e => { if(done) return; done = true; clearTimeout(timer); reject(e); },
		);
	});
}
